import { api } from '@/core/helpers/axiosHelper';

export default {
   async post(body: { board_id: number; company_id: number; sequence: number }) {
      return await api.post('/board-company', body).then((response) => {
         return response.data;
      });
   },
   async delete(board_company_id: number) {
      return await api.delete(`/board-company/${board_company_id}`);
   },
   async patch(board_company_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api.patch(`/board-company/${board_company_id}`, body);
   },
};
